<template>
  <div class="container bg-gray-100 mb-5 p-5">
    <router-link type="button" class="block text-left hover:underline" to="/personal-information">
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
    </router-link>
    <div class="container bg-white rounded-lg p-5 box-shadow">
      <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">
        Datos del dependiente económico <span>{{ kinship }}</span>
      </p>

      <form
        autocomplete="off"
        @submit.prevent="onSubmit()"
        class="flex flex-wrap text-left"
      >
        <div
          class="md:container lg:container xl:container lg:w-full xl:w-full  flex flex-wrap"
        >
          <div class="w-full mt-2">
            <div>
              <label class="mt-2 mb-2"> Apellido Paterno*: </label>
            </div>
            <div>
              <input
                id="input_last_name"
                type="text"
                v-model="paternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin números y sin caracteres especiales"
                @input="paternalLastName =$filters.capitalizeWords(paternalLastName)"
              />
            </div>
          </div>

          <div class="w-full mt-2">
            <div>
              <label class="mt-2 mb-2"> Apellido Materno: </label>
            </div>
            <div>
              <input
                id="input_mother_last_name"
                type="text"
                v-model="maternalLastName"
                class="w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="1"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Apellido debe tener un máximo de 30 caracteres, sin números y sin caracteres especiales"
                @input="maternalLastName =$filters.capitalizeWords(maternalLastName)"
              />
            </div>
          </div>

          <div class="w-full mt-2">
            <div>
              <label class="mt-2 mb-2"> Nombre*: </label>
            </div>
            <div>
              <input
                id="input_name_economic_dependent_data"
                type="text"
                v-model="name"
                class="capitalize w-full shadow-sm appearance-none border rounded py-2 px-3 text-grey-darker"
                maxlength="30"
                minlength="2"
                pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}"
                title="Nombre debe tener un máximo de 30 caracteres, sin números y sin caracteres especiales"
                @keyup="validateNameLentgth()"
                @input="name =$filters.capitalizeWords(name)"
              />
            </div>
            <span v-if="nameError" class="text-xs text-red-500 w-full">
                Nombre no válido 
            </span>
            
          </div>

          <div class="w-full lg:w-1/2 md:w-1/2">
            <div>
              <label class="mt-3 mb-2 w-full"> Género*: </label>
            </div>

            <div>
              <b-form-group class="mt-2 w-full">
                <b-form-radio-group
                  id="btn-radios-gender"
                  v-model="gender"
                  :options="optionsGender"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  name="radio-btn-stacked"
                >
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="w-full lg:w-1/2 md:w-1/2 mt-3">
            <div>
              <label class="mb-3 w-full"> Fecha de Nacimiento*: </label>
            </div>
            <div>
              <!-- <DatePicker
                v-model="date"
                :startDate="startDate"
                :minDate="new Date(1950, 1)"
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                textInput
                required
              ></DatePicker> -->

              <DatePicker
               id="input_birthdate"
              :startDate="startDate"
              :minDate="new Date(1900, 1)"
              :maxDate="new Date()"
               v-model="birthday"
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                textInput
                :yearRange="[1900, 2023]"
                cancelText="cancelar"
                selectText="seleccionar"
                locale="es"
                @update:modelValue="changeDate"
                autoApply
              />
              <span v-if="invalidDate" class="text-xs text-red-500 w-full">
                Fecha no válida
              </span>
            </div>
          </div>
        </div>

        <div class="w-full flex justify-center p-2 text-center mt-5 mb-2">
          <button
            id="button_next"
            class="w-full flex justify-center items-center md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded"
          >
            Siguiente <mdicon name="chevron-right"/>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from "moment";
import Swal from "sweetalert2";
import { validateExistenceOnLastName } from '../helpers/existenceOfLastName';

export default {
  name: "EconomicDependent",
  components:{DatePicker},
  data() {
    return {
      economicDependent: null,
      paternalLastName: '',
      maternalLastName: '',
      startDate: new Date(1964, 1),
      name: '',
      nameError: false,
      invalidDate: false,
      gender: "Hombre",
      optionsGender: [
        { text: "Hombre", value: "Hombre" },
        { text: "Mujer", value: "Mujer" },
      ],
      birthday: null,
      kinship: null,
      policy: null,
    };
  },
  created() {
    this.kinship = localStorage.getItem("kinship");
  },
  mounted() {
    
    if (
      JSON.parse(localStorage.getItem("detail_temp")) != undefined &&
      JSON.parse(localStorage.getItem("detail_temp")) != null
    ) {
      this.economicDependent = JSON.parse(localStorage.getItem("detail_temp"));
      this.editEconomicDependent();
    }
    this.getBirthDay()
  },
  methods: {
    isValididTextLength(text){
      return !(text?.length > 2 && text?.length < 30)
    },
    validateNameLentgth(){
      this.nameError =  this.isValididTextLength(this.name)
    },
    changeDate(modelData){
      const ageStorage = Number(localStorage.getItem("age") || '{}');
      const kinship = localStorage.getItem("kinship") || '{}';
      if(kinship !== "Titular"){
        let currentDate = moment();
        const age = moment(modelData, 'YYYY-MM-DD').diff(currentDate, 'years') * -1;

        if(isNaN(ageStorage)){
            return;
          }
        if(ageStorage !== age){
            Swal.fire({
              icon: 'warning',
              text: 'Fecha de nacimiento no coincide con edad ingresada en cotización',
              buttonConfirmText: 'ok'
            })
            this.birthday = '';
        }
      }

    },
    getBirthDay(){
      console.log("this.economicDependent; ", this.economicDependent)
      console.log("This Birthday: ",this)
    },
    editEconomicDependent() {
      this.paternalLastName = this.economicDependent.paternal_lastname;
      this.maternalLastName = this.economicDependent.maternal_lastname;
      this.name = this.economicDependent.first_name.concat(
        " ",
        this.economicDependent.second_name
      );
      this.gender = this.economicDependent.gender == "H" ? "Hombre" : "Mujer";
      this.birthday = this.economicDependent.date_birth;
      
    },
    onSubmit() {
      if(!validateExistenceOnLastName(this.maternalLastName, this.paternalLastName)){
        Swal.fire({
          icon: "warning",
          title: "Campos vacíos",
          text: "Favor de capturar al menos un apellido.",
        });
        return;
      }
      if(this.isValididTextLength(this.name)){
        this.nameError = true;
        return;
      }
      if(isNaN(this.birthday)){
        this.invalidDate = true;
        return;
      }
      if (this.validateBirthday()) {
        console.log("entras aqui");
        this.addEconomicDependent();
        this.$router.push({ name: "carga-identificacion" });
      }
    },
    validateBirthday() {
      var birth = moment(this.birthday, "DD/MM/YYYY").format("YYYY-MM-DD");
      var today = moment();
      var a = moment(today);
      var b = moment(birth);
      var agePolicy = a.diff(b, "year");
      console.log("agePolicy: ", agePolicy);
      console.log("b.isAfter(a): ", b.isAfter(a));
      if (b.isAfter(a)) {
        Swal.fire(
          "Fecha no admitida",
          "La fecha de nacimiento no puede ser mayor a la fecha actual.",
          "info"
        );
        return false;
      } else {
        let ageQuotation = localStorage.age;
        if (ageQuotation == agePolicy) {
          console.log({
            ageQuotation,
            agePolicy
          })
          return true;
        } else {
          Swal.fire(
            "Edad no admitida",
            "La fecha de nacimiento no coincide con la edad ingresada en la cotización",
            "info"
          );
          return false;
        }
      }
    },
    addEconomicDependent() {
      let detail_temp = {};
      let details_temp = JSON.parse(localStorage.getItem("details_temp"));
      let policy = JSON.parse(localStorage.getItem("policy"));
      //details_temp.forEach((details) => {
      // detalles de cada cobertura
      detail_temp.kinship = this.kinship;
      detail_temp.paternal_lastname = this.paternalLastName;
      detail_temp.maternal_lastname = this.maternalLastName;
      let array = this.name.split(" ");
      detail_temp.first_name = array[0];
      let secondName = "";
      for (var i = 1; i < array.length; i++) {
        secondName += array[i].replace(/^\w/, (c) => c.toUpperCase()) + " ";
      }
      detail_temp.second_name = secondName.substring(0, secondName.length - 1);
      detail_temp.gender = this.gender == "Hombre" ? "H" : "M";
      detail_temp.date_birth = moment(this.birthday).format("DD/MM/YYYY");
      //});
      if (this.kinship != "Titular") {
        detail_temp.selected_products = { details: details_temp };
        policy.client.selected_products = {};
        policy.client.beneficiaries = [];
      }
      policy.client.additionals_assured = [detail_temp];
      localStorage.setItem("policy", JSON.stringify(policy));
      localStorage.setItem("detail_temp", JSON.stringify(detail_temp));
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>